<div
  class="timesheet__item timesheet__status timesheet-column--status"
  [ngClass]="{
    'timesheet__status--approved': timesheet.status === 'Approved',
    'timesheet__status--declined': timesheet.status === 'Declined',
    'timesheet__status--pending': timesheet.status === 'Pending',
  }"
></div>

<div class="timesheet__item timesheet-column--start justify-between">
  {{ timesheet.starttime | time }}
  <shift-warning
    [absenceWarning]="absenceWarning"
    [doubleRegistration]="doubleRegistration"
    [deviatesFromSchedule]="deviationsFromSchedule.starttime"
  ></shift-warning>
</div>

@if (!timesheet.endtime) {
  <div class="timesheet__item timesheet-column--end">--:--</div>
}
@if (!!timesheet.endtime) {
  <div class="timesheet__item timesheet-column--end justify-between">
    {{ timesheet.endtime | time }}
    <shift-warning
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.endtime"
    ></shift-warning>
  </div>
}

@if (cols.break) {
  <div class="timesheet__item timesheet-column--break justify-between">
    {{ timesheet.break }}
    <shift-warning
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.break"
    ></shift-warning>
  </div>
}

@if (cols.paidBreak) {
  <div class="timesheet__item timesheet-column--paid-break justify-between">
    {{ timesheet.paid_break }}
    <shift-warning
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.paid_break"
    ></shift-warning>
  </div>
}

@if (cols.location) {
  <location-info [department]="department" [locations]="locations"> </location-info>
}

@if (cols.department) {
  <div class="timesheet__item timesheet-column--department">
    <timesheet-info
      [text]="department?.name"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.department"
    ></timesheet-info>
  </div>
}

@if (cols.team) {
  <div class="timesheet__item timesheet-column--team">
    <timesheet-info
      [text]="timesheet.Team?.name"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.team"
    >
    </timesheet-info>
  </div>
}

@if (cols.shift) {
  <div class="timesheet__item timesheet-column--shift">
    <timesheet-info
      [text]="timesheet.Shift?.long_name"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
      [deviatesFromSchedule]="deviationsFromSchedule.shift"
    >
    </timesheet-info>
  </div>
}

@if (cols.surcharge) {
  <div class="timesheet__item timesheet-column--surcharge">
    <timesheet-info
      [text]="surcharge"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
    ></timesheet-info>
  </div>
}

@if (cols.km) {
  <div class="timesheet__item timesheet-column--km">
    <timesheet-info
      text="{{ timesheet.kilometers | decimal }}"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
    ></timesheet-info>
  </div>
}

@if (cols.meals) {
  <div class="timesheet__item timesheet-column--meals">
    <timesheet-info
      [text]="timesheet.meals"
      [absenceWarning]="absenceWarning"
      [doubleRegistration]="doubleRegistration"
    ></timesheet-info>
  </div>
}

@if (cols.note) {
  <div class="timesheet__item timesheet-column--note">
    @if (timesheet.note) {
      <sb-badge [size]="'large'" color="indigo" [sbTooltip]="timesheet.note" [sbTooltipPlacement]="'top'">
        <sb-icon [name]="'comment'" />
      </sb-badge>
    }
  </div>
}

<timesheet-row-custom-fields
  [timesheet]="timesheet"
  [canEdit]="false"
  [columns]="customFieldCols"
  [customFields]="customFields"
></timesheet-row-custom-fields>

<div class="timesheet__item timesheet-column--details">
  <timesheet-details
    [timesheet]="timesheet"
    [absenceWarning]="absenceWarning"
    [doubleRegistration]="doubleRegistration"
    [cols]="cols"
  ></timesheet-details>
</div>
